import { atom } from "jotai";
import type { LineDetails } from "../types";

export const trafficOverviewLinesAtom = atom<LineDetails[]>([]);
export const trafficOverviewLabelAtom = atom<string | null>(null);
